import React from 'react'

export const UserContext = React.createContext()

export default function UserContextProvider({ value, children }) {
  return <UserContext.Provider value={value}>{children}</UserContext.Provider>
}
